import { atom } from 'recoil'
import { StateKeys } from '../../../../constants/stateKeys'
import { StorageKey } from '../../../../constants/StorageKey'
import { storageEffect } from '../../../../effects/storageEffect'
import { PlacePredictionCompat } from '../../../../hooks'

export interface CurrentSearchLocation extends PlacePredictionCompat {
  latitude?: number
  longitude?: number
  lat?: number // looks like in some instance we return lat instead of latitude
  lon?: number // looks like in some instance we return lon instead of longitude
  displayName: string
  stateAbbreviation: string
  name?: string | null
  level?: string
  id?: string | null
  formatted_address?: string | null
}

export const currentSearchLocation = atom<CurrentSearchLocation | undefined>({
  key: StateKeys.currentSearchLocation,
  default: undefined,
  effects: [storageEffect(StorageKey.CurrentSearchLocation)]
})
